// Overview is the project landing page; execution history remains under Runs.
let hasOverview = false;
export function setRegisteredPaths(paths: string[]) {
  hasOverview = paths.some((p) => /\/\$project\/overview\/?$/.test(p));
}
export function homePath(org: string, project: string): string {
  return `/${encodeURIComponent(org)}/${encodeURIComponent(project)}/${hasOverview ? "overview" : "runs"}`;
}
